import { cellClass, stickyCellClass } from "../_components/AdminTable";
import AdminRowActions, { DeleteButton, EditLink } from "../_components/AdminRowActions";

const CategoryItem = ({ deleteCategory, category, count }) => (
  <tr>
    <td className={cellClass}>{count + 1}</td>
    <td className={cellClass}>{category.categoryname}</td>
    <td className={stickyCellClass}>
      <AdminRowActions>
        <EditLink to={`/admin/categorylist/edit/${category._id}`} label="Edit category" />
        <DeleteButton
          label="Delete category"
          onClick={() => deleteCategory(category._id)}
        />
      </AdminRowActions>
    </td>
  </tr>
);

export default CategoryItem;
